import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'

import { environment } from '../../environments/environment'
import {
  AppSyncConflictDetail,
  AppSyncConflictOverview,
  AppSyncConflictResolveResult,
  AppSyncConflictScope
} from '../_models/app-sync-conflict.interface'

// Notfallspeicher der Techniker-App (siehe bentomax/hawk#573).
@Injectable({
  providedIn: 'root'
})
export class AppSyncConflictService {

  private basePath = environment.apiURL

  constructor(private http: HttpClient) {
  }

  // Vorgänge samt Wiederholungen. Die Zusammenfassung passiert serverseitig,
  // damit die Zählung in Liste und Mail dieselbe ist.
  public getOverview(scope: AppSyncConflictScope = 'open'): Observable<AppSyncConflictOverview> {
    const params = new HttpParams().set('scope', scope)

    return this.http.get<AppSyncConflictOverview>(`${this.basePath}app_sync_conflicts`, { params })
  }

  // Gesicherte Nutzdaten eines einzelnen Vorgangs.
  public getDetail(id: number): Observable<AppSyncConflictDetail> {
    return this.http.get<AppSyncConflictDetail>(`${this.basePath}app_sync_conflicts/${id}`)
  }

  // Hakt eine ganze Wiederholungsserie ab — sie ist fachlich ein Vorgang.
  public resolve(ids: number[]): Observable<AppSyncConflictResolveResult> {
    return this.http.patch<AppSyncConflictResolveResult>(
      `${this.basePath}app_sync_conflicts/resolve`, { ids }
    )
  }

  public reopen(ids: number[]): Observable<AppSyncConflictResolveResult> {
    return this.http.patch<AppSyncConflictResolveResult>(
      `${this.basePath}app_sync_conflicts/reopen`, { ids }
    )
  }
}
